import React from 'react';
export function TopBar() {
  return <div className="w-full bg-forest-900 px-4 py-2.5 text-center" data-id="element-294" data-mp="3sdwyhb040hms">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-gold-400 sm:text-xs" data-id="element-295" data-mp="232ngyqc68013">
        Oferta de lanzamiento · 6 tomos + 5 bonos gratis · Acceso inmediato
      </p>
    </div>;
}